import { MatchViewModel } from '../backend/entryPoints/mapper/mapToMatchViewModel';

export const DefaultGame: MatchViewModel = {
    games: [
        {
            home_points: 0,
            guest_points: 0,
        },
    ],
    mode: 1,
    mode_string: '1.MD',
    player_home: ['Home', 'Home'],
    player_guest: ['Guest', 'Guest'],
    home_team: 'BC Home',
    guest_team: 'BC Guest',
    player_positioning: [],
    server: -1,
    receiver: -1,
    serving_team: -1,
};
